import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { DangerousGoodsComponent } from "../dangerous-goods.component";
import { StepperService } from '../../stepper.service';
import { ShipmentService } from 'src/app/services/shipment.service';
import { ConfirmationService, MessageService } from 'primeng/api';

@Component({
  selector: 'app-dangerous-goods-modal-wrapper',
  standalone: true,
  imports: [DangerousGoodsComponent],
  template: `<app-dangerous-goods (EventToCloseModal)="CloseModal($event)" IsModal="true"></app-dangerous-goods>`,
  changeDetection: ChangeDetectionStrategy.Default,
})
export class DangerousGoodsModalWrapperComponent {

  constructor(private dynamicDialogConfig: DynamicDialogConfig, private dynamicDialogRef: DynamicDialogRef, private stepperService: StepperService, private shipmentService: ShipmentService, private messageService: MessageService) {

  }
  CloseModal(value: any) {
    if (value.UpdateData)
      this.UpdateAdrGoods();
    else
      this.dynamicDialogRef.close();
  }

  UpdateAdrGoods() {
    this.shipmentService.updateShipmentDangerousGoods(this.stepperService.newShipment).subscribe({
      next: (shipment) => {
        this.shipmentService.getFullShipment(this.stepperService.newShipment.id).subscribe((shipment) => {
          this.messageService.add({
            severity: 'success',
            summary: "Adr updated via modal",
            detail: "some more details here",
          });
        });
        this.dynamicDialogRef.close();
      },
      error: (err) => {
        this.messageService.add({
          severity: 'error',
          summary: "Error",
          detail: err,
        });
      },
    });
  }
}
